<template>
  <Messenger
    :title="problem.description"
    :description="problem.remarks"
    :back-link="
      problem.space
        ? route('problem.detect', [tenant.slug, problem.space.id])
        : undefined
    "
    :back-link-label="problem.space.name"
  >
    <template v-slot:content>
      <div class="flex flex-col h-full">
        <MessengerTabs class="grow" :tabs="tabs" />
        <div
          class="p-4 flex flex-col gap-2 items-stretch border-t border-gray-200"
        >
          <primary-button
            :label="t('components.messenger.public_replies.upvote')"
            @click="handleUpvoteProblem"
            :loading="isLoading.upvote"
          />
          <span
            class="cursor-pointer text-sm text-gray-600 hover:text-gray-500 font-semibold text-center"
            @click="handleReportDifferentProblem"
          >
            {{
              t("components.messenger.public_replies.report_another_problem")
            }}
          </span>
        </div>
      </div>
    </template>
  </Messenger>
</template>

<script setup>
import { usePage } from "@inertiajs/vue3";
import PrimaryButton from "@/Tailwind/Components/Buttons/PrimaryButton.vue";
import { router } from "@inertiajs/vue3";
import route from "ziggy-js";
import Messenger from "@/Tailwind/Layouts/Messenger.vue";
import { computed, reactive } from "vue";

import MessengerTabs from "@/Tailwind/Components/Messenger/MessengerTabs.vue";

import ProblemImageList from "@/Tailwind/Components/Messenger/Lists/ProblemImageList.vue";
import ProblemCommentList from "@/Tailwind/Components/Messenger/Lists/ProblemCommentList.vue";

import { useI18n } from "vue-i18n";
const { t } = useI18n();

const isLoading = reactive({
  upvote: false,
  new: false,
});

const problem = usePage().props.problem;
const tenant = usePage().props.tenant;
const comments = usePage().props.comments;

const tabs = computed(() => [
  {
    key: "updates",
    label: t("components.messenger.public_replies.updates"),
    count: comments.length,
    component: ProblemCommentList,
    componentAttributes: {
      comments,
    },
    emptyTitle: t("components.messenger.public_replies.no_updates"),
    emptyDescription: t("components.messenger.public_replies.no_updates_desc"),
    emptyImage: "/images/empty/updates.svg",
  },
  {
    key: "images",
    label: t("components.messenger.public_replies.images"),
    count: problem.photos.length,
    component: ProblemImageList,
    componentAttributes: {
      images: problem.photos,
    },
    emptyTitle: t("components.messenger.public_replies.no_images"),
    emptyDescription: t("components.messenger.public_replies.no_images_desc"),
    emptyImage: "/images/empty/files.svg",
  },
]);

function handleUpvoteProblem() {
  router.post(
    route("problems.upvotes.store", [tenant.slug, problem.id]),
    {},
    {
      onStart: () => (isLoading.upvote = true),
      onFinish: () => (isLoading.upvote = false),
    }
  );
}

function handleReportDifferentProblem() {
  router.get(
    route("problem.draft", [tenant.slug, problem.space.id]),
    {},
    {
      onStart: () => (isLoading.new = true),
      onFinish: () => (isLoading.new = false),
    }
  );
}
</script>
